interface String {
  capitalize(): string;
}

String.prototype.capitalize = function(): string {
  return this[0].toUpperCase() + this.slice(1);
};
